import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, scrollToMiddle_Vertical, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import { provideInfoContextKey_Protocol } from '../../../../../modules/provide-info/types.js';
import { ModuleFE_ProvideInfo } from '../../../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { PathwayStateType_Initial, PathwayStateType_Reassess, TransitionCondition } from '@app/pathway-shared';
import { Component_ProtocolStepStatusIndicatorV2 } from '../../../next-steps/working-diagnosis/Component_ProtocolStepStatusIndicator/Component_ProtocolStepStatusIndicator.js';
import { Component_MakeDecisionProtocol_StepProceed } from '../../../next-steps/working-diagnosis/Component_MakeDecision/renderers/Component_MakeDecisionProtocol_StepProceed/Component_MakeDecisionProtocol_StepProceed.js';
import { ModuleFE_AdvisorMini } from '../../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_Home } from '@app/advisor-v5-shared';
import { Component_PrettyPrint_Expression } from '@app/hcs-frontend/ui-components';
import { ModuleFE_Advisor_Expression, ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
import './Component_ProvideInfoV2_Protocol.scss';
import { voidFunction } from '@nu-art/ts-common';
import { Component_ProvideInfo_Input } from '../Component_ProvideInfo_Input/Component_ProvideInfo_Input.js';
import { FadeScrollWrapper } from '@app/styles';
import { Component_ProvideInfoV2_Controls } from '../../footer/Component_ProvideInfoV2_Controls/Component_ProvideInfoV2_Controls.js';
import { Component_ProtocolInfo } from '../../../protocol-info/Component_ProtocolInfo.js';
import { createRef } from 'react';
import { calculateActualValueMap, calculatePartialValueMap, calculateSuggestedValueMap } from '../utils.js';
import { ToasterPortal_BottomUp } from '@nu-art/toasting';
import { ToastFilter_ProtocolNavigation } from '../../../../../modules/provide-info/toasting.js';
export class Component_ProvideInfoV2_Protocol extends ComponentSync {
    __onProvideInfoContextChange = voidFunction;
    __onProvideInfoContextUpdate = (context) => this.forceUpdate();
    scrollData = { ref: createRef() };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.contextData = nextProps.contextData;
        return state;
    }
    componentDidMount() {
        this.scrollData.selectedVarId = this.state.contextData.input.varId;
        this.scrollToSelectedVar();
    }
    componentDidUpdate() {
        if (this.state.contextData.input.varId === this.scrollData.selectedVarId)
            return;
        this.scrollData.selectedVarId = this.state.contextData.input.varId;
        this.scrollToSelectedVar();
    }
    //######################### Logic #########################
    scrollToSelectedVar = () => {
        if (!this.state.contextData.navMode || !this.scrollData.selectedVarId)
            return;
        const container = this.scrollData.ref.current;
        if (!container)
            return;
        const selectedRow = container.querySelector('.case-description.selected');
        if (!selectedRow)
            return;
        scrollToMiddle_Vertical(selectedRow, container, 'smooth');
    };
    getStepClassName = (step) => {
        const selectedStepTransitionId = ModuleFE_ProvideInfo.getCurrentProtocolContextData()?.selectedStepTransitionId;
        return _className('provide-info__protocol-step', step.transition._id === selectedStepTransitionId && 'selected', step.transitionCondition === TransitionCondition.GO_TO_TRANSITION && 'go-to', step.transitionCondition === TransitionCondition.RES_FUNC_FALSE && 'no-go');
    };
    onVariableIdSelected = (step, variableId) => {
        ModuleFE_ProvideInfo.context.current.selectVariable(variableId);
    };
    //######################### Render #########################
    render() {
        if (this.state.contextData.navMode)
            return this.render_ProtocolNavigation();
        return _jsx(Component_ProtocolInfo, {});
    }
    //######################### Render - Navigation #########################
    render_ProtocolNavigation = () => {
        const actualValueMap = calculateActualValueMap(this.state.contextData);
        const suggestedValueMap = calculateSuggestedValueMap(this.state.contextData);
        const partialValueMap = calculatePartialValueMap(this.state.contextData);
        const inputKey = `protocol-${this.state.contextData.protocolData.protocol._id}`;
        return _jsxs(_Fragment, { children: [_jsx(FadeScrollWrapper, { className: 'provide-info__protocol', scrollRef: this.scrollData.ref, children: this.state.contextData.nextSteps.map(step => this.render_ProtocolStep(step, actualValueMap, suggestedValueMap, partialValueMap)) }), _jsx(Component_ProvideInfoV2_Controls, { contextData: this.state.contextData, type: provideInfoContextKey_Protocol }), _jsx(Component_ProvideInfo_Input, { contextData: this.state.contextData }, inputKey), _jsx(ToasterPortal_BottomUp, { bottomOffset: 16, height: 128, modelFilter: ToastFilter_ProtocolNavigation })] });
    };
    render_ProtocolStep = (step, actualValueMap, suggestedValueMap, partialValueMap) => {
        const collapsed = !this.state.contextData.openedSteps[step.relatedExpression._id];
        return _jsx(TS_CollapsableContainerV2, { className: this.getStepClassName(step), headerRenderer: () => this.render_StepHeader(step), containerRenderer: () => this.render_StepBody(step, actualValueMap, suggestedValueMap, partialValueMap), customCaret: () => this.render_StepIndicator(step), collapsed: collapsed, onCollapseToggle: () => ModuleFE_ProvideInfo.protocol.toggleStep(step), animated: true, forceUpdate: true }, step.transition._id);
    };
    render_StepIndicator = (step) => {
        return _jsx(Component_ProtocolStepStatusIndicatorV2, { status: step.transitionCondition, targetIsReassessment: step.targetState.type === PathwayStateType_Reassess, originIsInitial: step.originState.type === PathwayStateType_Initial });
    };
    render_StepHeader = (step) => {
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'provide-info__protocol-step-title', children: step.transition.label }), _jsx(Component_MakeDecisionProtocol_StepProceed, { nextStep: step, onPostSubmit: () => ModuleFE_AdvisorMini.openPanel(PanelKey_Home) })] });
    };
    render_StepBody = (step, actualValueMap, suggestedValueMap, partialValueMap) => {
        return _jsx(Component_PrettyPrint_Expression, { modules: {
                variable: ModuleFE_Advisor_Variable,
                value: ModuleFE_Advisor_Value,
                expression: ModuleFE_Advisor_Expression,
            }, expression: step.relatedExpression, guidelines: true, interactive: true, interactiveProperties: {
                calculationResult: step.calculationResult,
                actualValueMap: actualValueMap,
                suggestedValueMap: suggestedValueMap,
                partialValueMap: partialValueMap,
                valueTree: step.valueTree,
                selectedVariableId: this.state.contextData.input.varId,
                onVariableSelected: varId => this.onVariableIdSelected(step, varId),
            } });
    };
}
//# sourceMappingURL=Component_ProvideInfoV2_Protocol.js.map